module.exports = __webpack_public_path__ + "static/media/AccountCircleWhite.810a48fe.svg";